import { jsxs, jsx } from 'react/jsx-runtime';

function LookingGlass() {
  return jsxs("svg", {
    fill: "none",
    height: "160",
    role: "img",
    width: "160",
    xmlns: "http://www.w3.org/2000/svg",
    children: [jsx("title", {
      children: "Looking glass over a page"
    }), jsxs("g", {
      filter: "url(#filter0_d)",
      children: [jsx("path", {
        d: "M13.333 13.333h96v128h-96z",
        fill: "#F7F7F7"
      }), jsx("path", {
        d: "M98.667 39.333h-32v1.334h32v-1.334zM98.667 42h-32v1.333h32V42zM98.667 44.667h-32V46h32v-1.333z",
        fill: "#DDDCDC"
      }), jsx("path", {
        d: "M25 55V30.333h35.333V55H25z",
        fill: "#fff",
        stroke: "#F7F7F7",
        strokeWidth: "2"
      }), jsx("path", {
        d: "M58.667 32h-32v21.333h32V32z",
        fill: "#fff",
        opacity: ".5"
      }), jsx("path", {
        d: "M32 40a2.667 2.667 0 100-5.333A2.667 2.667 0 0032 40zM27.708 51.032l7.125-9.365 4.33 2.667 7.29-7.194 6.248 7.194L56.833 34l1.834 19.333h-32l1.04-2.301z",
        fill: "#FEBBB6",
        opacity: ".4"
      }), jsx("path", {
        d: "M98.667 74h-32v1.333h32V74zM98.667 76.667h-32V78h32v-1.333zM98.667 79.333h-32v1.334h32v-1.334z",
        fill: "#DDDCDC"
      }), jsx("path", {
        d: "M25 89.667V65h35.333v24.667H25z",
        fill: "#fff",
        stroke: "#F7F7F7",
        strokeWidth: "2"
      }), jsx("path", {
        d: "M58.667 66.667h-32V88h32V66.667z",
        fill: "#fff",
        opacity: ".5"
      }), jsx("path", {
        d: "M32 74.667a2.667 2.667 0 100-5.334 2.667 2.667 0 000 5.334zM27.708 85.699l7.125-9.366 4.33 2.668 7.29-7.195 6.248 7.195 4.132-10.334L58.667 88h-32l1.04-2.301z",
        fill: "#FEBBB6",
        opacity: ".4"
      }), jsx("path", {
        d: "M98.667 108.667h-32V110h32v-1.333zM98.667 111.333h-32v1.334h32v-1.334zM98.667 114h-32v1.333h32V114z",
        fill: "#DDDCDC"
      }), jsx("path", {
        d: "M25 124.333V99.667h35.333v24.666H25z",
        fill: "#fff",
        stroke: "#F7F7F7",
        strokeWidth: "2"
      }), jsx("path", {
        d: "M58.667 101.333h-32v21.334h32v-21.334z",
        fill: "#fff",
        opacity: ".5"
      }), jsx("path", {
        d: "M32 109.333A2.667 2.667 0 1032 104a2.667 2.667 0 000 5.333zM27.708 120.365L34.833 111l4.33 2.668 7.29-7.195 6.248 7.195 4.132-10.335 1.834 19.334h-32l1.04-2.302z",
        fill: "#FEBBB6",
        opacity: ".4"
      })]
    }), jsxs("g", {
      filter: "url(#filter1_d)",
      children: [jsx("path", {
        d: "M58.418 8.933l92.729 24.847-30.368 113.335-92.73-24.847z",
        fill: "#fff"
      }), jsx("path", {
        d: "M130.402 36.503L64.075 18.73l-.345 1.288 66.327 17.772.345-1.288z",
        fill: "#DDDCDC"
      }), jsx("path", {
        d: "M95.513 34.056L62.35 25.17l-.345 1.288 33.163 8.886.345-1.288z",
        fill: "#DDDCDC",
        opacity: ".7"
      }), jsx("path", {
        d: "M120.512 47.656L60.624 31.61l-.345 1.288 59.888 16.046.345-1.288z",
        fill: "#DDDCDC"
      }), jsx("path", {
        d: "M73.388 41.931l-14.49-3.882-.344 1.288 14.489 3.882.345-1.288z",
        fill: "#DDDCDC",
        opacity: ".7"
      }), jsx("path", {
        d: "M123.5 62.26L57.173 44.49l-.344 1.288 66.326 17.772.345-1.288zM121.835 68.717L55.448 50.928l-.345 1.288 66.388 17.789.344-1.288z",
        fill: "#DDDCDC"
      }), jsx("path", {
        d: "M67.107 69.236l7.727 2.07-6.211 23.183-7.728-2.07z",
        fill: "#006899"
      }), jsx("path", {
        d: "M78.605 77.839l7.727 2.07-4.831 18.031-7.727-2.07z",
        fill: "#91CE23"
      }), jsx("path", {
        d: "M88.724 91.593l7.727 2.07-2.07 7.728-7.728-2.07z",
        fill: "#980A00"
      }), jsx("path", {
        d: "M104.363 84.74l7.728 2.07-4.832 18.032-7.727-2.071z",
        fill: "#FD0"
      }), jsx("path", {
        d: "M107.626 121.504l-66.327-17.772-.345 1.288 66.327 17.772.345-1.288zM91.09 123.975l-51.516-13.803-.345 1.288 51.516 13.803.345-1.288z",
        fill: "#DDDCDC"
      }), jsx("path", {
        d: "M57.167 121.787l-19.319-5.176-.345 1.288 19.319 5.176.345-1.288z",
        fill: "#DDDCDC",
        opacity: ".7"
      })]
    }), jsxs("g", {
      fill: "#C40D00",
      filter: "url(#filter2_d)",
      children: [jsx("path", {
        d: "M128.767 62.788a31.502 31.502 0 00-10.247-6.947 32.044 32.044 0 00-12.199-2.507c-4.196-.03-8.356.76-12.235 2.327a31.515 31.515 0 00-10.352 6.795c-11.91 11.754-12.111 30.893-.463 42.896 5.118 5.273 11.976 8.603 19.361 9.4 7.384.798 14.819-.989 20.988-5.043l22.743 23.164a1.553 1.553 0 002.166.042l5.668-5.336a1.48 1.48 0 00.042-2.12l-22.746-23.162c4.361-5.85 6.478-13.015 5.979-20.24-.498-7.225-3.581-14.047-8.705-19.269zm-7.085 37.224a22.676 22.676 0 01-11.642 5.807 22.943 22.943 0 01-12.975-1.504 22.387 22.387 0 01-9.935-8.308 21.692 21.692 0 01-3.546-12.312A21.722 21.722 0 0187.62 71.53a22.436 22.436 0 0110.261-7.919 22.959 22.959 0 0113.026-1.004 22.639 22.639 0 0111.4 6.25 21.986 21.986 0 014.734 7.242 21.63 21.63 0 011.544 8.463 21.636 21.636 0 01-1.883 8.398 22.013 22.013 0 01-5.021 7.053z"
      }), jsx("path", {
        d: "M89.415 78.012c-2.531 0-2.535 3.852 0 3.852s2.535-3.852 0-3.852zM107.058 65.677c-6.812-.15-13.01 3.196-16.307 8.247-1.075 1.648 1.978 3.104 3.048 1.464 2.73-4.181 7.914-6.837 13.524-6.7 5.877.145 11.226 3.437 14.058 8.006 1.074 1.733 3.89.158 2.826-1.565-3.45-5.549-10.11-9.303-17.149-9.452z"
      })]
    }), jsxs("defs", {
      children: [jsxs("filter", {
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse",
        height: "132",
        id: "filter0_d",
        width: "98",
        x: "11.333",
        y: "13.333",
        children: [jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), jsx("feOffset", {
          dx: "-2",
          dy: "4"
        }), jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        }), jsx("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow"
        }), jsx("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow",
          result: "shape"
        })]
      }), jsxs("filter", {
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse",
        height: "142.182",
        id: "filter1_d",
        width: "125.097",
        x: "26.05",
        y: "8.933",
        children: [jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), jsx("feOffset", {
          dx: "-2",
          dy: "4"
        }), jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        }), jsx("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow"
        }), jsx("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow",
          result: "shape"
        })]
      }), jsxs("filter", {
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse",
        height: "84",
        id: "filter2_d",
        width: "82",
        x: "72.667",
        y: "53.333",
        children: [jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), jsx("feOffset", {
          dx: "-2",
          dy: "4"
        }), jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        }), jsx("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow"
        }), jsx("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow",
          result: "shape"
        })]
      })]
    })]
  });
}

export { LookingGlass as default };
//# sourceMappingURL=LookingGlass.js.map
